import { Component } from '@angular/core'

@Component({
  selector: 'se-po-dob-select-docs',
  templateUrl: './dob-select-docs.component.html',
  styleUrls: ['./dob-select-docs.component.scss'],
  standalone: false,
})
export class DobSelectDocsComponent {
}
